/**
 * PostAuth.tsx
 *
 * This file defines the layout for authenticated pages.
 * It serves as a wrapper for the components that require user authentication.
 */

import { ReactNode } from 'react';
import { PostAuthProvidersWrapper } from '@/components/providers';
import ProtectedRoute from '@/lib/route';

interface PostAuthProps {
  children: ReactNode;
}

const PostAuth = ({ children }: PostAuthProps) => (
  <ProtectedRoute>
    <PostAuthProvidersWrapper>{children}</PostAuthProvidersWrapper>
  </ProtectedRoute>
);

export default PostAuth;
